module.exports = __webpack_public_path__ + "img/camera_equirect_icon.12e8f6df.png";